import React, { Component, Fragment } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { GetUsers, Alerts } from '../../../helpers';
import { Link } from 'react-router-dom';

import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Card,
    CardContent,
    Typography,
    Box
} from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';

const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Users",
        page_path: "/app/users",
        icon: "circle",
    }
]
export default class UsersList extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: true,
            data: [],
            user_role:''
        }
    }

    getData = async () => {
        let resp = await GetUsers.getAllUsers();
        if (resp) {
            if (resp.status) {
                this.setState({
                    data: resp.users,
                    isLoading: false,
                })
            }

            //console.log(resp);
        }
    }
    getDataWithQuery = async (role) => {

        let resp = await GetUsers.getAllUsersWithQuery(role);
        if (resp) {
            if (resp.status) {
                this.setState({
                    data: resp.users,
                    isLoading: false,
                })
            }

            console.log(resp);
        }
    }
    componentDidMount() {
        this.getData();
    }
    handleApprove = async (id) => {
        let resp = await GetUsers.activateDeactiveUser(id);
        if (resp) {
            Alerts.alertMessage(resp, "", "success");
            window.location.reload();
        }
    }
    handleRoleChange = (e) =>{
      this.setState({
        user_role:e.target.value
      },() =>{
        this.getDataWithQuery(this.state.user_role)
      })
    }
    render() {
        const { data, isLoading, user_role } = this.state;

        const options = {
            filter: false,
            download:false,
            print:false,
            selectableRows: false
        };
        const columns = ["#SL", "User ID", "Name", "Email", "Phone", "Roles", "isActive", "Approval", "Settings"]
        return (
            <Fragment>
                <Breadcumb items={BreadcrumbData} />
                <div className="page-wrapper mt20">
                    <Container >
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                            <Box  mt={1} mb={1}>
                            
                            <Card className="card" spacing={2}>
                                    <CardContent>
                                        <Typography variant="h5" gutterBottom>
                                           Role wise user filter
                                        </Typography>
                                        <FormControl className={`formControl, flw100`}>
                                            <InputLabel id="demo-simple-select-label" style={{ left:"10px", top:'0px' }}>User Type</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="gender"
                                                variant="filled"
                                                value={user_role}
                                                onChange={this.handleRoleChange}
                                                fullWidth={true}
                                            >
                                                <MenuItem value=" ">All Users</MenuItem>
                                                <MenuItem value="customer">Customer</MenuItem>
                                                <MenuItem value="admin">Admin</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </CardContent>
                                </Card>

</Box>

                            </Grid>

                        </Grid>

                        {isLoading ? "Data Loading..." : <MUIDataTable
                            title="Users List"
                            data={data.map((item, i) => {

                                return [
                                    ++i,
                                    item.id,
                                    item.fname,
                                    item.email,
                                    item.mobile_number,
                                    item.roles.map((val) => {
                                        return <>{val.name}<br /></>
                                    }),
                                    <div className={`status-pills ${item.is_active ? "pills-success" : "pills-close"}`}>{item.is_active ? 'Active' : 'Inactive'}</div>,
                                    <button className={`btn2 ${item.is_active ? 'danger-bg' : 'success-bg'}`} onClick={() => this.handleApprove(item.id)}>{item.is_active ? "Inactive" : 'Activate'}</button>,
                                    <Link to={`/app/users/${item.id}`} className="btn-secondry action-btn">
                                        <SettingsIcon fontSize="small" />
                                    </Link>


                                ]
                            })}
                            columns={columns}
                            options={options}
                        />
                        }
                    </Container>
                </div>
            </Fragment>
        )
    }
}
